
<i class="fa" :class="selector"></i>
